import { useId } from "react";

const useEnsureId = (id?: string): string => {
  const generatedId = useId();

  return id || generatedId;
};

export default useEnsureId;
